import { BaseComponent, cssHelper } from "react-vextensions";
//import ReactTooltip from "react-tooltip";
import Tooltip from "rc-tooltip";
import { Button } from "react-vcomponents";
import React from "react";
import { E } from "js-vextensions";
import { InTooltip } from "./Tooltip.js";
class TooltipInfo {
    constructor(text, effect) {
        this.text = text;
        this.effect = effect;
        this.id = ++lastTipID;
    }
    get IDStr() { return `tooltip_${this.id}`; }
}
const tooltips = [];
let lastTipID = -1;
export class InfoButton extends BaseComponent {
    ComponentWillMountOrReceiveProps(props) {
        if (this.tooltip)
            this.DestroyTooltip();
        this.CreateTooltip(props);
    }
    ComponentWillUnmount() {
        this.DestroyTooltip();
    }
    DestroyTooltip() {
        tooltips.Remove(this.tooltip);
        this.tooltip = null;
    }
    CreateTooltip(props) {
        const { text, effect } = props;
        this.tooltip = new TooltipInfo(text, effect);
        tooltips.push(this.tooltip);
        /*if (InfoButton_TooltipWrapper.main) {
            InfoButton_TooltipWrapper.main.Update(()=>ReactTooltip.rebuild());
        }*/
    }
    render() {
        var _a;
        const { text, effect, tooltipProps, sel, style, ...rest } = this.props;
        const tooltip = (React.createElement(InTooltip, { ...E(tooltipProps, sel && { className: `${tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.className} selectable` }) }, text));
        const { css } = cssHelper(this);
        return (React.createElement(Tooltip, { placement: "top", overlay: tooltip },
            React.createElement(Button, { ...rest, size: 13, iconSize: 13, iconPath: "/Images/Buttons/Info.png", useOpacityForHover: true, style: css({
                    position: `relative`, zIndex: 1, marginLeft: 1, alignSelf: "center",
                    backgroundPosition: "center", // fsr, this is set to "-1px -1px" by default, which cuts off 1px of the image
                    backgroundColor: null, boxShadow: null, border: null,
                }, 
                //{marginTop: "auto", marginBottom: "auto"}, // maybe use this; it vertically-centers in parent, without need for {alignItems: "center"} on parent
                style), "data-tip": true, "data-for": (_a = this.tooltip) === null || _a === void 0 ? void 0 : _a.IDStr })));
    }
}
InfoButton.defaultProps = { effect: "solid" };
// we have to use an outside-of-scrollview tooltip-wrapper, because "position: fixed" does not work under an element with "willChange: transform"
/*export class InfoButton_TooltipWrapper extends BaseComponent<{}, {}> {
    static main: InfoButton_TooltipWrapper;
    ComponentDidMount() {
        InfoButton_TooltipWrapper.main = this;
    }
    ComponentWillUnmount() {
        InfoButton_TooltipWrapper.main = null;
    }
    render() {
        return (
            <div>
                {tooltips.map((tooltip, index)=> {
                    return (
                        <ReactTooltip key={index} id={tooltip.IDStr} effect={tooltip.effect}>
                            <Pre>{tooltip.text}</Pre>
                        </ReactTooltip>
                    );
                })}
            </div>
        );
    }
}*/ 
//# sourceMappingURL=InfoButton.js.map